


















import {Component, Vue} from 'vue-property-decorator';

@Component({
  components: {},
})
export default class LoggedIn extends Vue {
  protected origin: string = process.env.url;
  protected links: { adviserPortalUrl: string, quoteUrl: string } = {
    ...(window as any).user.links,
  };
}
